module.exports = "/images/ss-logo-white-bg.png?6e4cda2651a4cc64c998e257c3156c4b";